export type ShippingCaseResponse = {
  id: number;
  label: string;
  title: string;
  packing_list_generation_type: string;
  terminal?: {
    id: number;
    name: string;
    port_id?: number;
  } | null;
  offer: {
    id: number;
    flow_of_goods: string;
    mode_of_transport: string;
    type_of_shipment: string;
    container_shipment_type?: string;
    incoterm: string;
    object_it: string;
    object_eng: string;
    loading_port?: {
      id: number;
      name: string;
      country: string;
      title: string;
    } | null;
    discharge_port?: {
      id: number;
      name: string;
      country: string;
      title: string;
    } | null;
    terminals?:
      | {
          id: number;
          name: string;
          port_id: number;
        }[]
      | null;
    customer: {
      id: number;
      erp_id: number;
      name: string | null;
      email: string | null;
      address: string | null;
      payment_details: string | null;
    };
    operator: {
      id: number;
      inviter_id: number;
      email: string;
      first_name: string;
      last_name: string;
      role: string;
      status: string;
      last_login: string;
      created_at: string;
      updated_at: string;
    };
    assigned_office: {
      id: number;
      name: string;
      country: string;
      title: string;
    };
    place_of_receipt: PlaceOfReceipt | null;
    place_of_delivery: PlaceOfDelivery | null;
    commodities: Commodity[];
  };
  activities: ActivityItem[];
  cargo_docs: Document[];
  unloading_special_instruction: string;
  unloading_note: string;
  total_containers: number;
  total_gross_weight: number;
  total_net_weight: number;
  total_pieces: number;
};

export type Commodity = {
  id: number;
  name: string;
  name_it: string;
};

export type PlaceOfReceipt = {
  id: number;
  name: string;
  province: string;
  // TODO CHECK COUNTRY
  country: string;
  post_code: string;
  title: string;
  deleted_at: string | null;
};

export type PlaceOfDelivery = {
  id: number;
  name: string;
  province: string;
  // TODO CHECK COUNTRY
  country: string;
  post_code: string;
  title: string;
  deleted_at: string | null;
};

export type Document = {
  name: string;
  path: string;
  original: boolean;
  updated_by: string;
  presigned_url: string;
};

export type ShippingCaseService = {
  id: number;
  description: string;
  updated_at: string;
  completed: boolean;
};

export type ActivityItem = {
  id: number;
  activity_id: number;
  completed: boolean;
  completed_by_id: number;
  created_at: string;
  completion_date: string | null;
  execution_date: string | null;
  description: string | null;
  supplier: SupplierType;
  comment: string | null;
  route: string;
};

export type ActivityItemsResponse = {
  items: ActivityItem[];
  total: number;
  page: number;
  size: number;
  pages: number;
};

export type ActivitiesResponse = {
  [key: string]: ShippingCaseService[];
} | null;

export enum ModeOfTransport {
  "MARITIME" = "Maritime Transport",
  "LAND" = "Land Transport",
  "AIR" = "Air Transport",
}

export enum ShippingCaseFields {
  FLOW_OF_GOODS = "Flow of Goods",
  MODE_OF_TRANSPORT = "Mode of Transport",
  TYPE_OF_CARGO = "Type Of Cargo",
  ASSIGNED_OFFICE = "Assigned Office",
  REFFERENCE_OFFER = "Refference Offer",
  SEAWAY_USER = "Seaway User",
  INCOTERMS = "Incoterms",
  CUSTOMER_DETAILS = "Customer Details",
  NUMBER_OF_SHIPPING = "Number of Shipping",
  DISCHARGE_PORT = "Discharge Port",
  TERMINAL = "Terminal",
}

export enum Sections {
  SERVICES = "General Details",
}

export type MappedOffer = {
  [Sections.SERVICES]: {
    [ShippingCaseFields.CUSTOMER_DETAILS]: string;
    [ShippingCaseFields.NUMBER_OF_SHIPPING]: number;
    [ShippingCaseFields.FLOW_OF_GOODS]: string;
    [ShippingCaseFields.MODE_OF_TRANSPORT]: string;
    [ShippingCaseFields.TYPE_OF_CARGO]: string;
    [ShippingCaseFields.ASSIGNED_OFFICE]: string;
    [ShippingCaseFields.REFFERENCE_OFFER]: number;
    [ShippingCaseFields.SEAWAY_USER]: string;
    [ShippingCaseFields.INCOTERMS]: string;
    [ShippingCaseFields.DISCHARGE_PORT]: string;
    [ShippingCaseFields.TERMINAL]: string;
  };
};

export enum ActivitiesFields {
  "CUSTOMS" = "Customs",
  "DELIVERY" = "Delivery",
  "FREIGHT" = "Freight",
  "INSURANCE" = "Insurance",
  "ORIGIN_CHARGE" = "Origin Charge",
  "UNLOADING" = "Unloading",
  "WAREHOUSING" = "Warehousing",
}

export enum CargoDocs {
  "BILL_OF_LADING" = "Bill Of Lading",
  "CERTIFICATE_OF_ORIGIN" = "Certificate of origine",
  "INVOICE" = "Invoice",
  "PACKING_LIST" = "P. List",
  "MILL_TEST_CERTIFICATE" = "Mill test certificate MTC",
  "CONTRACT" = "Contratto",
  "INSURANCE_CERTIFICATE" = "Certificato assicurazione",
  "null" = "Free text document",
}

export interface SupplierType {
  id: number;
  name: string;
}

export type CreateOriginFields = {
  comment?: string | null;
  execution_date?: string | null;
  completion_date?: string | null;
  supplier_id?: number;
};

export type ProducerType = {
  id: number;
  name: string;
  company_type: string[];
  is_customer: boolean;
  country: string;
};

export type ProducerMillType = {
  id: number;
  name: string;
  company_type: string[];
  is_customer: boolean;
  country: string;
};

export type ProductionMethodType = {
  id: number;
  name: string;
};

export type PaginationModel = {
  page: number;
  pageSize: number;
};
